module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/mobile@2x-0f2c0aa64bced3139e6e7b4e72616fb0.jpg";